/* eslint-disable camelcase */
// The client advertising report, opened with its type already settled.
//
// There is one schedule dialog now, and this is the door into it that the
// unified table uses when an existing client report is edited: the two
// families post to different endpoints, so the type of a saved schedule is
// fixed and `lockedKind` says so. Creating from scratch goes through the same
// dialog with the type list open, so nobody has to know which family their
// report belongs to before choosing it.
import { useMemo } from 'react';
import PropTypes from 'prop-types';
import ScheduleDialog from '../reportSchedules/ScheduleDialog';
import { CLIENT, clientFormToSchedule } from '../reportSchedules/scheduleDialogModel';

export default function ClientReportForm({ initial, state, onClose }) {
  // Stable identity: the dialog follows a replaced `initial` (the host swaps
  // it in when a fetched record arrives), so rebuilding this object on every
  // render would discard whatever had been typed.
  const scheduleForm = useMemo(() => clientFormToSchedule(initial.practice_ids?.[0], initial), [initial]);
  return (
    <ScheduleDialog
      initial={scheduleForm}
      lockedKind={CLIENT}
      clientState={state}
      onClose={onClose}
    />
  );
}

ClientReportForm.propTypes = {
  initial: PropTypes.object.isRequired,
  state: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};
